<template>
  <div class="container">
    <div class="logo"></div>
    <div class="main"></div>
    <div class="content">
      <div class="title">
        <p>With Pooca</p>
        <p>Grow Into Your Best Self</p>
      </div>
      <div class="scene"></div>
      <div class="info">
        <div class="desc">
          <p>
            Pooca is an Al companion that grows with you. With five unique personalities, Pooca
            listens, chats, and supports you through every mood and moment.
          </p>
          <p>
            As you discover more about yourself, you'll also see your Pooca Island flourish — a
            reflection of your own journey of growth.
          </p>
        </div>
      </div>
      <div class="planet"></div>
    </div>
    <div class="concat">
      <div class="title">Contact Us</div>
      <div class="concat-container">
        <div class="item">
          <img src="./imgs/company.webp" />
          <div class="item-content">
            <p class="title">Company</p>
            <p class="subtitle">NATUREAI TECHNOLOGY PTE. LTD.</p>
          </div>
        </div>
        <div class="item">
          <img src="./imgs/address.webp" />
          <div class="item-content">
            <p class="title">Address</p>
            <p class="subtitle">192 WATERLOO STREET #06-08 SKYLINE SINGAPORE</p>
          </div>
        </div>
        <div class="item">
          <img src="./imgs/mail.webp" />
          <div class="item-content">
            <p class="title">Legal contact email</p>
            <p class="subtitle">legal@pooca.ai</p>
          </div>
        </div>
        <div class="item">
          <img src="./imgs/mail.webp" />
          <div class="item-content">
            <p class="title">Support email</p>
            <p class="subtitle">support@pooca.ai</p>
          </div>
        </div>
      </div>
      <div class="concat-policy">
        <a href="/static/hy/pooca/terms/index.html">Terms</a>｜<a
          href="/static/hy/pooca/privacy/index.html"
          >Privacy Policy</a
        >
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.container {
  background-image: url('./imgs/m-bg.webp');
  background-size: 100vw 5.64rem;
  background-repeat: no-repeat;
  padding-top: 0.36rem;
}
.logo {
  margin: 0 0 0 0.36rem;
  width: 1.31rem;
  height: 0.41rem;
  background-image: url('./imgs/logo.webp');
  background-size: 100% 100%;
}
.main {
  margin: 0.46rem auto 0;
  width: 6rem;
  height: 3.37rem;
  background-image: url('./imgs/main.webp');
  background-size: 100% 100%;
}
.content {
  position: relative;
  border-radius: 0.64rem 0.64rem 0px 0px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.48rem 0 0.84rem;
  .title {
    p {
      font-family: SF Pro;
      font-size: 24px;
      font-weight: 860;
      line-height: 0.6rem;
      text-align: center;
      color: #1b1b1b;
    }
    p + p {
      margin-top: 6px;
    }
  }
  .scene {
    margin-top: -0.7rem;
    width: 6.52rem;
    height: 6.5rem;
    background-image: url('./imgs/island.webp');
    background-size: 100% 100%;
  }
  .info {
    padding: 0 0.32rem;
    .desc {
      margin-top: -0.42rem;
      p {
        font-family: SF Pro;
        font-size: 14px;
        font-weight: normal;
        line-height: 0.4rem;
        letter-spacing: normal;
        color: rgba(0, 0, 0, 0.8);
      }
      p + p {
        margin-top: 0.12rem;
      }
    }
  }
  .planet {
    position: absolute;
    right: 0.32rem;
    bottom: 0.24rem;
    width: 0.76rem;
    height: 0.6rem;
    background-image: url('./imgs/plant.webp');
    background-size: 100% 100%;
  }
}
.concat {
  padding: 0.48rem 0 0.36rem;
  background: #f1f9f1;
  .title {
    text-align: center;
    margin: 0 auto;
    font-family: SF Pro;
    font-size: 24px;
    font-weight: 860;
    line-height: 0.6rem;
    text-align: center;
    letter-spacing: normal;
    color: #1b1b1b;
  }
  &-container {
    margin-top: 0.32rem;
    padding: 0 0.32rem;
    display: flex;
    flex-direction: column;
    .item {
      padding: 0.24rem;
      box-sizing: border-box;
      border-radius: 0.32rem;
      background: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 0.64rem;
        height: 0.64rem;
      }
      &-content {
        flex: 1;
        margin-left: 0.24rem;
        .title {
          text-align: left;
          font-size: 16px;
          font-weight: 590;
          line-height: 0.4rem;
          letter-spacing: normal;
          color: #334932;
        }
        .subtitle {
          margin-top: 0.08rem;
          font-family: SF Pro;
          font-size: 14px;
          font-weight: normal;
          line-height: 0.36rem;
          letter-spacing: normal;
          color: #5a785a;
        }
      }
    }
    .item + .item {
      margin-top: 0.24rem;
    }
  }
  &-policy {
    margin-top: 0.56rem;
    text-align: center;
    font-size: 14px;
    font-weight: 510;
    line-height: 0.48rem;
    letter-spacing: normal;
    color: rgba(0, 0, 0, 0.5);
  }
}
</style>

<style lang="css">
html,
body,
#app {
  background-color: #c0eae3;
}
</style>
